import styled from 'styled-components';
import { lightGrey1Color, lightGrey2Color } from 'js/config/style';
import Row from '../Row';

export default styled(Row)`
  cursor: pointer;
  border-top: 1px solid ${lightGrey1Color};

  &:first-child,
    border-top: none;
  }

  &:hover .inner {
    background-color: ${lightGrey2Color};
  }
`;
